import { numberFormat as u } from "./index.es278.js";
const m = (t, i, e) => {
  var o;
  const r = (o = t == null ? void 0 : t.ranks) == null ? void 0 : o[i], n = r && u({
    number: r.rank,
    maximumFractionDigits: 1,
    shorten: !0,
    formatThousands: !0
  }), a = r && u({
    number: r.total,
    maximumFractionDigits: 1,
    shorten: !0,
    formatThousands: !0
  }), s = r && `${n}/${a}`;
  if (r && e === "rank")
    return s;
  if (r && e === "percentile")
    return `${r.percentile}%`;
}, d = (t, i, e) => {
  if (!t || t.rank_error || e)
    return {
      rankMetric: void 0,
      visitMetricValue: void 0
    };
  const o = t[i] || void 0, r = o != null && o.value ? u({
    number: o.value,
    maximumFractionDigits: 1,
    shorten: !0,
    formatThousands: !0
  }) : void 0, n = t.SALES_EST || void 0, a = t.SALES_SQ_FT_EST || void 0, s = t.TRANSACTIONS_EST || void 0;
  return {
    rankMetric: o,
    visitMetricValue: r,
    salesMetric: n,
    salesSqFtMetric: a,
    transactionsMetric: s
  };
};
export {
  m as getRankBy,
  d as getRankMetrics
};
//# sourceMappingURL=index.es432.js.map
